import React from "react";
import { ListItem, Grid, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CustomListItem from "./customListItem";

export interface MenuItemProps {
  label: string;
  disabled?: boolean;
  onClick: () => void;
  type?: "default" | "hold";
}

interface ListItemProps {
  label?: string;
  data?: string;
  color?: string;
  icon?: React.ReactNode;
  thumbnailPath?: string;
  action?: string;
  display?: boolean;
  thumbNailOnClick?: (event: any) => void;
  menuItems?: MenuItemProps[];
}

interface CustomListRowProps {
  row: ListItemProps[];
  i: number;
  onClick?: () => void;
  mobileColumnRender?: boolean;
  handleMenuItemsMoreMenuClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

const CustomListRow: React.FC<CustomListRowProps> = ({
  row,
  i,
  onClick,
  mobileColumnRender,
  handleMenuItemsMoreMenuClick,
  disabled
}) => {
  const theme = useTheme();
  const matchDownSm = useMediaQuery(theme.breakpoints.down("sm"));

  // Assuming controlWidth1 and controlWidth2 are the widths for the columns you want to control specifically
  let controlWidth1 = 3.0; // Example fixed width for a specific column
  const controlWidth2 = 0.7; // Another example fixed width

  // Calculate the total fixed width of controlled columns
  const totalFixedWidth = controlWidth1 + controlWidth2;

  // Calculate available space after removing fixed width columns and not displayed columns
  // Assuming 12 is the total grid space available
  const totalColumns = 12;
  const notDisplayedColumns = 2; // Columns not rendered
  const displayedColumns =
    row.filter((item) => item.display !== false).length - notDisplayedColumns;

  // Calculate the width for each of the remaining displayed columns
  const remainingSpace = totalColumns - totalFixedWidth;
  const widthPerColumn = remainingSpace / displayedColumns;

  return (
    <ListItem divider={true} sx={{ p: 1 }}>
      <Grid
        container
        rowSpacing={1.5}
        sx={{ display: "flex", width: "100%", justifyContent: "space-between", opacity: disabled ? 0.7 : 1 }}
      >
        {row.map((item, index) => {
          if (item.display === false) return null; // Skip rendering

          let xs = widthPerColumn; // Default width

          // Apply specific widths based on conditions
          if ((item.label && item.color) || ((item.thumbnailPath || item.icon) && item.label))
            xs = controlWidth1;
          if (item.action === "row-menu" || item.data === undefined) xs = controlWidth2;

          if (mobileColumnRender && matchDownSm) xs = 12; // Full width on small screens

          return (
            <Grid item key={index} xs={xs} sx={{ display: "flex", justifyContent: "flex-start" }}>
              <CustomListItem
                label={item.label}
                data={item.data}
                color={item.color}
                icon={item.icon}
                thumbnailPath={item.thumbnailPath}
                action={item.action}
                menuItems={item.menuItems}
                thumbNailOnClick={onClick}
                menuItemsMoreMenuClick={handleMenuItemsMoreMenuClick}
              />
            </Grid>
          );
        })}
      </Grid>
    </ListItem>
  );
};

export default CustomListRow;
